/**
 * Widget URL Builder Utility
 * Builds the correct widget iframe URL based on environment
 */

/**
 * Get the widget base URL based on the current environment
 */
function getWidgetBaseUrl(): string {
  // Check for explicit override
  if (import.meta.env.VITE_WIDGET_BASE_URL) {
    return import.meta.env.VITE_WIDGET_BASE_URL;
  }

  // Determine environment
  const isDev = import.meta.env.DEV || import.meta.env.MODE === 'development';
  const isStaging = typeof window !== 'undefined' && 
    (window.location.hostname.includes('staging') || 
     import.meta.env.VITE_FIREBASE_PROJECT_ID?.includes('staging'));

  if (isDev) {
    return 'http://localhost:5175';
  } else if (isStaging) {
    return 'https://10seat-widget-staging.web.app';
  } else {
    return 'https://reserve.10seat.com';
  }
}

/**
 * Build the widget iframe URL with query parameters
 * @param locationId - The location ID for the widget
 * @param restaurantName - Optional restaurant name to display in widget
 * @param locale - Optional initial locale code
 * @returns The complete widget iframe URL
 */
export function getWidgetUrl(locationId: string, restaurantName?: string, locale?: string): string {
  if (!locationId) {
    throw new Error('Location ID is required to build widget URL');
  }

  const baseUrl = getWidgetBaseUrl();
  const params = new URLSearchParams({
    location: locationId,
    theme: 'light',
    mode: 'embedded',
    syncLanguage: '1', // Indicate this widget should sync with parent language
  });

  if (restaurantName) {
    params.set('name', restaurantName);
  }

  if (locale) {
    params.set('lang', locale);
  }

  return `${baseUrl}/embedded.html?${params.toString()}`;
}

